module.exports = __webpack_public_path__ + "static/media/ufo-beam.d6b93958.svg";